import {AbstractControl, FormControl, FormGroup, ValidatorFn,} from "@angular/forms";
import {Component, Input, OnInit} from "@angular/core";

import {ParametroFuncao} from "src/app/funcao/models/parametro-funcao";

@Component({
  selector: "app-parametro-funcao-percentual",
  templateUrl: "./parametro-funcao-percentual.component.html",
  styleUrls: ["./parametro-funcao-percentual.component.scss"],
})
export class ParametroFuncaoPercentualComponent implements OnInit {
  constructor() {
  }

  @Input() schema: ParametroFuncao = {
    descricao: "",
    endpointOpcoes: "",
    label: "",
    obrigatorio: false,
    ordem: 0,
    parametroVinculado: "",
    parametros: [],
    tamanhoMaximoExibicao: 0,
    tipo: undefined,
    obrigatorioSe: [],
    variavel: ""

  };
  @Input() schemaParent: ParametroFuncao = {
    descricao: "",
    endpointOpcoes: "",
    label: "",
    obrigatorio: false,
    ordem: 0,
    parametroVinculado: "",
    parametros: [],
    tamanhoMaximoExibicao: 0,
    tipo: undefined,
    variavel: ""

  };
  @Input() formGroup: FormGroup = new FormGroup({});
  @Input() value: any;
  @Input() readonly = false;

  public formControl = new FormControl();
  public required: boolean;

  ngOnInit(): void {

    this.formControl = new FormControl();
    this.formControl.setValidators([
      this.valorPercentualMenorCem(),
      this.valorPercentualMaiorZero(),
    ]);

    this.formGroup.addControl(this.schema.variavel, this.formControl);

    this.required = this.schema.obrigatorio || this.schemaParent.obrigatorio;

    this.formControl.setValue(this.value);

    if (this.readonly)
      this.formControl.disable()
  }

  private valorPercentualMenorCem(): ValidatorFn {
    return (control: FormControl): { [key: string]: any } | null => {
      const valid = control.value == null || control.value <= 100;
      return valid ? null : {valorMaiorCem: !valid};
    };
  }

  private valorPercentualMaiorZero(): ValidatorFn {
    return (control: FormControl): { [key: string]: any } | null => {
      const valid = control.value == null || control.value >= 0;
      return valid ? null : {valorMenorZero: !valid};
    };
  }

  hasRequiredField = (abstractControl: AbstractControl): boolean => {
    if (abstractControl.validator) {
      const validator = abstractControl.validator({} as AbstractControl);
      if (validator && validator.required) {
        return true;
      }
    }
    if (abstractControl['controls']) {
      for (const controlName in abstractControl['controls']) {
        if (abstractControl['controls'][controlName]) {
          if (this.hasRequiredField(abstractControl['controls'][controlName])) {
            return true;
          }
        }
      }
    }
    return false;
  };
}
